import styled from 'styled-components';

export const EntireContainer = styled.div`
    width: 100%;
`;

export const BackFrame = styled.div`
    width: 100%;
    z-index: -10;
    background-color: #fff;
    position: fixed;
`;
